import { Component, OnInit, Input } from '@angular/core';
import { Shared } from '../shared.service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {

  @Input() settings;
  tab = 'details';

  constructor(public shared: Shared) { }

  ngOnInit() {
  }

  isTab(tab){
      return tab === this.tab;
  }

  setTab(tab){
      this.tab = tab;
  }

  toggleTabs(){
    this.shared.settings_tabs = !this.shared.settings_tabs;
  }

  closeTabs(){
    this.shared.settings_tabs = false;
  }

  closeMenu(){
      this.shared.mobile_menu = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/settings/settings.component.ts